import React, {createContext, useContext} from 'react';

const SidebarContext = createContext({
  isCollapsed: false,
});

export const SidebarProvider = ({children, isCollapsed}) => {
  return (
    <SidebarContext.Provider value={{isCollapsed}}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  return useContext(SidebarContext);
};
